import React from 'react';
import { LogVars, Output, Comment, Presets, Settings } from '../../components/';

export const Logs = () => (
  <>
    <Presets />
    <Settings />
    <LogVars />
    <Comment />
    <Output />
  </>
);
